import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header.js";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config";

function Home() {
  const [user, setUser] = useState(null);

  // ✅ This will run once when page loads and fetch user session
  useEffect(() => {
    document.title = "Home | Webyappy";

    fetch(`${API_BASE_URL}/auth/check_session`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "active") {
          setUser(data.user); // ✅ Now user is set
        }
      });
  }, []);

  // ✅ This avoids crashing while user data is still loading
  if (!user) {
    return <div className="text-center p-5">Loading...</div>;
  }

  // ✅ Your departments and microapps with correct structure
  const allDepartments = [
    {
      id: "crm",
      title: "CRM",
      icon: "fas fa-users",
      link: "/pages/crm/CRM",
      apps: [
        { id: "crm_add_lead" },
        { id: "crm_view_lead" },
        { id: "crm_edit_lead" },
      ],
    },
    {
      id: "invoicing",
      title: "Invoicing",
      icon: "fas fa-file-invoice",
      link: "/pages/invoicing/Invoicing",
      apps: [
        { id: "inv_create_pi" },
        { id: "inv_view_pi" },
        { id: "inv_edit_pi" },
        { id: "inv_create_tax_standalone" },
        { id: "inv_create_tax_from_pi" },
        { id: "inv_view_tax" },
      ],
    },
    {
      id: "settings",
      title: "Settings",
      icon: "fas fa-cog",
      link: "/pages/settings/Settings",
      apps: [
        { id: "settings_add_user" },
        { id: "settings_view_user" },
        { id: "settings_assign_microapp" },
      ],
    },
  ];

  // ✅ Filter visible departments based on role or assigned microapps
  const visibleDepartments =
    user.role.toLowerCase() === "superadmin"
      ? allDepartments
      : allDepartments.filter((dept) =>
          dept.apps.some((app) => user.assigned_microapps?.includes(app.id)),
        );

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid py-5 bg-light">
          <div className="row gx-3 gy-4">
            {visibleDepartments.map((dept) => (
              <div className="col-lg-3 col-xl-3 col-6" key={dept.id}>
                <Link
                  to={dept.link}
                  className="btn btn-block bg-white main-department-card text-dark-50 text-center py-10 px-5 pt-4 w-100 p-4 p-lg-5"
                >
                  <i
                    className={`${dept.icon} fa-lg-4x fa-3x mb-3 pt-2 main-department-icon`}
                  ></i>
                  <div className="font-weight-bold font-size-h6">
                    {dept.title}
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
